module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAMAAAAM7l6QAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUdwTBZs9gxm+hds9Rds9RZr9RVq9hRr9RFo8hZr9Rds9hRq9RNr9hVq9Axo+BJq9hVr9RZr9hZs9RZr9RNq9Rdr9RZ2t8MAAAAVdFJOUwC5CunXmDlZHb71ZkF7FCqLx6rkMSl4o9AAAADdSURBVCjPrZPrDoMgDEYrUIFy89b3f9WpqHNakyXb8YcmJ1DKVwF+Jnhzw4fdIpvmhuGu2mn/+ASprG/LRdKR7aYdoL8Qof1eC5y0arZ2gqghYSXKWm08bN7rSgJQNgV3WR0Qu+WZIGrWRAnkk7fkJ+U6TrL2Zq2POks6L9uuOVhRc+28yFqNQ50AbsXaaV0+6V7Jd96wx4HG8hBJ5FGPhO++99x3HZUyuJSvAcw3muxB4hbAeNtRvyWQG+IToQ+GmYb8btcdWCaancvyzM9HKwPj0y/h/Dy3GOAfvABiLw+Yoe91yQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/homePage/more7.png
// module id = A79c
// module chunks = 0